import {
    Label,
    Table
} from 'reactstrap';
import { SquareCheckbox } from '../../../../components/Inputs/SquareCheckbox/SquareCheckbox';
import { UserAccountType } from '../../../../constants/UserAccountType';
import { FaUser, FaUsers } from 'react-icons/fa';
import './UserSections.css';
import { locationModalTypes } from '../../../../constants/treeState';
import UserStatus from '../../UserStatus/UserStatus';
import Button from '../../../../components/UIButton/UIButton';
import { useAuth } from "react-oidc-context";


export default function AccountTypeAndStatus({ modalData, accountSwitch, modalType, openRemoveUserModal, toggleParentModal }) {
    const loggedInUserEmail = useAuth()?.user?.profile?.email;
    const isModalUserSameAsLoggedInUser = modalData?.userData?.email === loggedInUserEmail;  
    const singleUserLabel = (
        <>
            <FaUser className="mr-1 single-user-icon" />
            <span>Single User</span>
        </>
    );
    const sharedUserLabel = (
        <>
            <FaUsers className="mr-1 shared-user-icon" />
            <span>Shared User</span>
        </>
    );
    return (
        <Table borderless className="w-100 mb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
            <tbody>
                <tr>
                    {/* Account Type column */}
                    <td className="pe-4 align-middle w-50">
                        <div className="d-flex align-items-center">
                            <Label className="mb-0 me-3">Account type:</Label>
                            <div className="form-check d-flex align-items-center">
                                <SquareCheckbox value={modalData.accountType === UserAccountType.Single}
                                    valueChangeHandler={() => accountSwitch(UserAccountType.Single)}
                                    label={singleUserLabel}
                                    id="chk-single-user"
                                    disabled={modalData.accountType !== UserAccountType.Single && modalType === locationModalTypes.Edit}
                                    size="small"
                                />
                            </div>
                            <div className="form-check d-flex align-items-center">
                                <SquareCheckbox value={modalData.accountType === UserAccountType.Shared}
                                    valueChangeHandler={() => accountSwitch(UserAccountType.Shared)}
                                    label={sharedUserLabel}
                                    id="chk-shared-user"
                                    disabled={modalData.accountType !== UserAccountType.Shared && modalType === locationModalTypes.Edit}
                                    size="small"
                                />
                            </div>
                        </div>
                    </td>

                    {/* Divider and User Status column */}
                    <td
                        className="ps-4 align-middle"
                        style={{ borderLeft: "1px solid #dee2e6", width: "50%" }}
                    >
                        {modalType !== locationModalTypes.Add && (
                            <div className="d-flex align-items-center">
                                <Button
                                    variant="danger"
                                    size="small"
                                    onClick={() => {
                                        toggleParentModal();
                                        openRemoveUserModal(modalData?.accountId);
                                    }}
                                    disabled={isModalUserSameAsLoggedInUser}
                                >
                                    Remove User
                                </Button>
                                <Label className="mb-0 ml-5">
                                    User Status: <UserStatus status={modalData.userStatus} />
                                </Label>
                            </div>
                        )}
                    </td>


                </tr>
            </tbody>
        </Table>
    )
}